import { useState, useEffect } from 'react';

/**
 * Hook pro smooth loading s minimálním zobrazením skeleton
 * Zajistí že skeleton bude vidět alespoň minDelay ms
 */
export const useDelayedLoading = (actualLoading, minDelay = 300) => {
  const [showLoading, setShowLoading] = useState(true);
  const [startTime, setStartTime] = useState(Date.now());

  useEffect(() => {
    if (actualLoading) {
      setStartTime(Date.now());
      setShowLoading(true);
    } else {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(0, minDelay - elapsed);
      
      if (remaining > 0) {
        const timer = setTimeout(() => setShowLoading(false), remaining);
        return () => clearTimeout(timer);
      } else {
        setShowLoading(false);
      }
    }
  }, [actualLoading, minDelay, startTime]);

  return showLoading;
};

export default useDelayedLoading;
